import axiosWrapper, { InterceptorOptions } from './axios-wrapper'

const api = axiosWrapper.create(
  {
    baseURL: '/tracer',
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  },
  InterceptorOptions.defaultErrorInterceptor,
)

export function apiGetTestZonesByPlantName({ plantName }) {
  return api.get(`/test-zones?plantName=${plantName}`).then((resp) => resp.data)
}
